import { IFormData } from '../../components/FormHelper/FormHelper.types';
import 'react-native-get-random-values';
import { v4 as uuidv4 } from 'uuid';

export function removeEmptyValues(obj: IFormData): IFormData {
  // Create a new object to hold the filtered key-value pairs
  const cleanedObj: Record<string, any> = {};

  for (const key in obj) {
    // Check if the value is not empty (undefined, null, '', or empty array)
    if (obj[key] !== undefined && obj[key] !== null && obj[key] !== '') {
      // If the value is an array, also check if it's not empty
      if (!Array.isArray(obj[key]) || obj[key].length > 0) {
        cleanedObj[key] = obj[key];
      }
    }
  }

  return cleanedObj;
}

export function generateUniqueId(): string {
  const uuid = uuidv4();

  return uuid;
}

export const htmlDecode = (input: any) => {
  var plainString = input.replace(/<[^>]+>/g, '');
  return plainString;
};
